import styled from 'styled-components';
import {Typography} from '@/components/Typography';
import {KodataNearbyStoreItem} from '@/map/@types';
import {convertToMyfcCategoryFromKodata} from '@/map/utils';
import {ColumnFlexBox, MultiLineEllipsis} from '@/styled-components';
import {BrandLogoBig} from '../../BrandLogoBig';
import {SwiperSlideCardWrapper} from '../Swiper/StyledComponents';

interface IProps {
  item: KodataNearbyStoreItem;
}

export const StoreCard = ({item}: IProps) => {
  const category = convertToMyfcCategoryFromKodata(item.category);

  return (
    <SwiperSlideCardWrapper>
      <Root>
        <ColumnFlexBox gap={8}>
          <MultiLineEllipsis lineClamp={2}>
            <Typography variant="medium16" fontWeight="700">
              {item.branchName}
            </Typography>
          </MultiLineEllipsis>
          {!!category && (
            <Typography variant="medium14" fontWeight="400">
              {category}
            </Typography>
          )}
        </ColumnFlexBox>
        <BrandLogoBig />
      </Root>
    </SwiperSlideCardWrapper>
  );
};

const Root = styled.div`
  padding: 0 16px;
  height: 96px;
  display: flex;
  gap: 16px;
  align-items: center;
  justify-content: space-between;
`;
